'use client';

import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { MultiSelectDropdown } from '../../../OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '../../../OffersFilter/useFilterEvents';
import { useFilterProductTypeOptions } from '../store/hooks';
import { useOffersFilterStore } from '../store/useOffersFilterStore';

export const ProductTypeSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  regionCode,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  regionCode?: StateAbbreviation;
}) => {
  const options = useFilterProductTypeOptions(regionCode);
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleChange = useCallback(
    (selectedLabels: string[]) => {
      if (scrollBackToMainBar) scrollBackToMainBar();
      setTimeout(
        () => {
          handleUpdateFilterFormState({ selectedProductTypes: selectedLabels });
          const newState = handleApplyFilters();
          if (!newState) return;
          updateFiltersEvent({
            additional_attributes: {
              product_types: selectedLabels,
              location: newState.appliedFilters.selectedLocation,
            },
          });
        },
        scrollBackToMainBar ? 100 : 0,
      );
    },
    [handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent, scrollBackToMainBar],
  );

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Product Type"
      options={options}
      selectedOptions={appliedFilters?.selectedProductTypes || []}
      onChange={handleChange}
      useStore={useOffersFilterStore}
    />
  );
};
